// Call the function on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJspcImgSliders);
} else {
    initJspcImgSliders();
}

function initJspcImgSliders() {
    // Select all elements with the class 'jspcimg-slider'
    var sliders = document.querySelectorAll('.pc25-images');
    sliders.forEach(function(slider) {
        // Check if Flickity is available and slider not already initialized
        if (typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
            // Initialize Flickity slider
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                imagesLoaded: true,
                wrapAround: true
            });
            // Remove the class to prevent re-initialization
            slider.classList.remove('jspcimg-slider');
        }
    });
}

document.addEventListener('change', function(event) {
    if (event.target.matches('.p25-select select')) {
        const selectElement = event.target;
        const selectedIndex = selectElement.selectedIndex; // Get the option's position (0-based)

        // Find the closest parent `.js-card`
        const parentCard = selectElement.closest('.pc25');
        if (parentCard) {
            const priceElement = parentCard.querySelector('.pc25-onetime');
            if (priceElement) {
                priceElement.setAttribute('data-shows', selectedIndex);
            }
        }
    }

    if (event.target.matches('.jspc-subscribe select')) {
        const selectElement = event.target;
        const selectedIndex = selectElement.selectedIndex; // Get the option's position (0-based)

        // Find the closest parent `.js-card`
        const parentCard = selectElement.closest('.js-card');
        if (parentCard) {
            const priceElement = parentCard.querySelector('.subs-price');
            if (priceElement) {
                priceElement.setAttribute('data-shows', selectedIndex);
            }
        }
    }
});

// Handle .pc25-add button click (similar to .jspc-add)
document.addEventListener('click', function(event) {
    const pc25AddButton = event.target.closest('.pc25-add');
    if (pc25AddButton) {
        event.preventDefault();
        const parentCard = pc25AddButton.closest('.pc25'); // Find closest parent .pc25
        if (parentCard) {
            // Find the select element inside .p25-select or .p25-selectbox
            const selectElement = parentCard.querySelector('.p25-select select, .p25-selectbox select');
            if (selectElement) {
                const selectedValue = selectElement.value; // Get selected value (JSON string)

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: selectedValue
                })
                    .then(res => res.json())
                    .then(data => {
                        if (typeof PROJ !== 'undefined' && PROJ.ajaxcart) {
                            PROJ.ajaxcart.updateCart();
                            PROJ.ajaxcart.opencart();
                        }
                    })
                    .catch(err => console.error('Error adding to cart:', err));
            }
        }
    }
});

// Popup variant selection and subscription switching
// All listeners are attached ONCE on document (event delegation) so they work
// when popup content is loaded via AJAX without re-attaching on every popup open.
(function() {
    'use strict';

    // --- Delegated click: quantity buttons ---
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.pc25-popup-overlay')) return;
        if (!e.target.closest('.pc25-quantity-wrap .pc25-quantity-btn')) return;
        e.preventDefault();
        const btn = e.target.closest('.pc25-quantity-btn');
        const quantityWrap = btn.closest('.pc25-quantity-wrap');
        const input = quantityWrap && quantityWrap.querySelector('input[type="number"]');
        if (!input) return;
        if (btn.classList.contains('pc25-min')) {
            if (parseInt(input.value, 10) > 1) {
                input.value = parseInt(input.value, 10) - 1;
                input.dispatchEvent(new Event('change'));
            }
        } else if (btn.classList.contains('pc25-plu')) {
            input.value = parseInt(input.value, 10) + 1;
            input.dispatchEvent(new Event('change'));
        }
    });

    // --- Delegated click: variant selection ---
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.pc25-popup-overlay')) return;
        const variantEl = e.target.closest('.pc25-sl-var.pc25-variable');
        if (!variantEl || variantEl.classList.contains('active')) return;
        e.preventDefault();
        e.stopPropagation();
        const popup = e.target.closest('.pc25-popup-overlay');
        const productForm = variantEl.closest('.pc25-product-form');
        if (!productForm) return;
        const variantId = variantEl.getAttribute('varid');
        const sellingPlan = variantEl.getAttribute('data-selling-plan') || '';
        const varPrice = variantEl.querySelector('.pc25-var-price');
        const priceReplace = productForm.querySelector('.pc25-price-replace');
        const formInput = productForm.querySelector('form input[name="id"]');
        const sellingPlanInput = productForm.querySelector('.pc25-selling-plan-id');
        const addButton = productForm.querySelector('button[type="submit"]');
        productForm.querySelectorAll('.pc25-variable').forEach(function(v) { v.classList.remove('active'); });
        variantEl.classList.add('active');
        if (sellingPlanInput) sellingPlanInput.value = sellingPlan;
        if (formInput) formInput.value = variantId;
        if (varPrice && priceReplace) priceReplace.innerHTML = varPrice.innerHTML;
        if (addButton) {
            if (variantEl.classList.contains('available')) addButton.removeAttribute('disabled');
            else addButton.setAttribute('disabled', '');
        }
        const imgVarId = variantEl.getAttribute('data-imgvar-id');
        if (imgVarId && typeof Flickity !== 'undefined') {
            const gallerySlides = popup.querySelectorAll('.pc25-sl-med[data-assign-var]');
            var slideIndex = -1;
            gallerySlides.forEach(function(slide, index) {
                if (slide.getAttribute('data-assign-var') === imgVarId) slideIndex = index;
            });
            if (slideIndex >= 0) {
                const mainGallery = popup.querySelector('.pc25-sl-main-gal');
                if (mainGallery) {
                    const flickityInstance = Flickity.data(mainGallery);
                    if (flickityInstance) flickityInstance.select(slideIndex);
                }
            }
        }
    });

    // --- Delegated click: plan selector (One-time / Subscribe) ---
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.pc25-popup-overlay')) return;
        const item = e.target.closest('.pc25-plan-selector .pc25-oitem');
        if (!item) return;
        e.preventDefault();
        const popup = e.target.closest('.pc25-popup-overlay');
        const planSelector = item.closest('.pc25-plan-selector');
        if (!planSelector) return;
        planSelector.querySelectorAll('.pc25-oitem').forEach(function(i) { i.classList.remove('active'); });
        const productForm = item.closest('.pc25-product-form');
        if (productForm) {
            productForm.querySelectorAll('.pc25-js-option').forEach(function(opt) { opt.classList.remove('active'); });
        }
        item.classList.add('active');
        const targetClass = item.getAttribute('data-link');
        if (targetClass) {
            const targetOption = popup.querySelector('.' + targetClass);
            if (targetOption) {
                targetOption.classList.add('active');
                const firstVariant = targetOption.querySelector('.pc25-sl-var.pc25-variable');
                if (firstVariant) firstVariant.click();
            }
            const slProductForm = popup.querySelector('.pc25-sl-product-form');
            if (slProductForm) slProductForm.setAttribute('plantype', targetClass);
        }
    });

    // --- Delegated change: selling plan select ---
    document.addEventListener('change', function(e) {
        if (!e.target.closest('.pc25-popup-overlay')) return;
        if (!e.target.matches('.pc25-selling-plan-change')) return;
        e.preventDefault();
        const select = e.target;
        const variantEl = select.closest('[data-selling-plan]');
        const productForm = select.closest('.pc25-product-form');
        if (variantEl && productForm) {
            variantEl.setAttribute('data-selling-plan', select.value);
            const sellingPlanInput = productForm.querySelector('.pc25-selling-plan-id');
            if (sellingPlanInput) sellingPlanInput.value = select.value;
        }
    });

    // --- Delegated submit: popup form add to cart (capture so we run first) ---
    document.addEventListener('submit', function(e) {
        const form = e.target.closest('form[action="/cart/add"]');
        if (!form || !form.closest('.pc25-popup-overlay')) return;
        e.preventDefault();
        e.stopPropagation();
        const productForm = form.closest('.pc25-product-form');
        const formData = new FormData(form);
        const formDataObj = {};
        formData.forEach(function(value, key) { formDataObj[key] = value; });
        if (productForm) {
            const idInput = productForm.querySelector('form input[name="id"]');
            const sellingPlanInput = productForm.querySelector('.pc25-selling-plan-id');
            if (idInput) formDataObj.id = idInput.value;
            if (sellingPlanInput && sellingPlanInput.value) {
                formDataObj.selling_plan = sellingPlanInput.value;
            } else {
                delete formDataObj.selling_plan;
            }
            const qtyInput = productForm.querySelector('input[name="quantity"]');
            if (qtyInput) formDataObj.quantity = qtyInput.value || 1;
        }
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.classList.add('pc25-add-loading');
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(formDataObj).toString()
        })
        .then(function(response) {
            if (!response || typeof response.json !== 'function') throw new Error('Invalid response from server');
            return response.json();
        })
        .then(function(itemData) {
            if (itemData && itemData.message) console.warn('Cart add response:', itemData.message);
            if (typeof PROJ !== 'undefined' && PROJ.ajaxcart) {
                PROJ.ajaxcart.updateCart();
                PROJ.ajaxcart.opencart();
            }
            if (typeof closeProductPopup === 'function') closeProductPopup();
            if (submitBtn) submitBtn.classList.remove('pc25-add-loading');
        })
        .catch(function(error) {
            console.error('Error adding to cart:', error);
            if (typeof PROJ !== 'undefined' && PROJ.ajaxcart) PROJ.ajaxcart.updateCart();
            if (submitBtn) submitBtn.classList.remove('pc25-add-loading');
        });
        return false;
    }, true);

    // No-op; kept so any external call to initPopupForm (e.g. loadProductPopup) does not break
    function initPopupForm() {}
    window.initPopupForm = initPopupForm;
})();

// Load product popup function (isBundle = use bb-popup-overlay for bundle Quick View)
function loadProductPopup(handle, isBundle) {
    if (!handle) return;

    const popupContent = document.querySelector(`[data-zpro25-pop="${handle}"]`);
    if (!popupContent) return;

    const overlaySel = isBundle ? '.bb-popup-overlay' : '.pc25-popup-overlay';
    const popupOverlay = document.querySelector(overlaySel);
    const popupContainer = popupOverlay ? popupOverlay.querySelector(isBundle ? '.bb-popup' : '.pc25-popup') : null;

    if (!popupOverlay || !popupContainer) return;

    const closeSel = isBundle ? '.bb-popup-close' : '.pc25-popup-close';
    const closeButton = popupContainer.querySelector(closeSel);

    popupContainer.innerHTML = popupContent.innerHTML;

    if (closeButton && popupContainer.firstChild) {
        popupContainer.insertBefore(closeButton, popupContainer.firstChild);
    } else if (closeButton) {
        popupContainer.appendChild(closeButton);
    }

    popupOverlay.style.display = 'block';
    document.body.classList.add('qv-open');
    document.body.style.overflow = 'hidden';

    setTimeout(function() {
        popupContainer.classList.add('active');
    }, 10);

    setTimeout(function() {
        const mainGalSel = isBundle ? '.bb-popup-main-gal' : '.pc25-sl-main-gal';
        const thumbGalSel = isBundle ? '.bb-popup-thumb-gal' : '.pc25-vs-thumb-gal';
        const mainGallery = popupContainer.querySelector(mainGalSel);
        const thumbGallery = popupContainer.querySelector(thumbGalSel);

        if (mainGallery && typeof Flickity !== 'undefined') {
            const existingInstance = Flickity.data(mainGallery);
            if (existingInstance) {
                existingInstance.destroy();
            }
            new Flickity(mainGallery, {
                cellAlign: 'center',
                contain: true,
                pageDots: false,
                prevNextButtons: false,
            });

            if (thumbGallery) {
                const existingThumbInstance = Flickity.data(thumbGallery);
                if (existingThumbInstance) {
                    existingThumbInstance.destroy();
                }
                new Flickity(thumbGallery, {
                    cellAlign: 'center',
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    asNavFor: mainGallery
                });
            }
        }
        initAccordion(popupOverlay);
    }, 100);
}

// Close popup function (popupOverlayEl optional: overlay that was clicked or that is visible)
function closeProductPopup(popupOverlayEl) {
    let popupOverlay = popupOverlayEl;
    if (!popupOverlay) {
        const a = document.querySelector('.pc25-popup-overlay');
        const b = document.querySelector('.bb-popup-overlay');
        popupOverlay = (a && a.style.display === 'block') ? a : (b && b.style.display === 'block') ? b : a || b;
    }
    if (!popupOverlay) return;

    const popupContainer = popupOverlay.querySelector('.pc25-popup') || popupOverlay.querySelector('.bb-popup');

    if (popupContainer) {
        popupContainer.classList.remove('active');
        setTimeout(function() {
            popupOverlay.style.display = 'none';
            document.body.style.overflow = '';
            document.body.classList.remove('qv-open');
        }, 300);
    } else {
        popupOverlay.style.display = 'none';
        document.body.style.overflow = '';
        document.body.classList.remove('qv-open');
    }
}

// Handle click on elements with data-call-product-popup attribute
document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-call-product-popup]');
    if (trigger) {
        e.preventDefault();
        const handle = trigger.getAttribute('data-call-product-popup');
        const isBundle = trigger.classList.contains('bb-quick-view');
        if (handle) {
            loadProductPopup(handle, isBundle);
        }
    }

    const overlayClicked = e.target.closest('.pc25-popup-overlay') || e.target.closest('.bb-popup-overlay');
    if (e.target.classList.contains('pc25-popup-overlay') || e.target.classList.contains('bb-popup-overlay')) {
        closeProductPopup(overlayClicked);
    }

    if (e.target.closest('.pc25-popup-close') || e.target.closest('.bb-popup-close')) {
        closeProductPopup(e.target.closest('.pc25-popup-overlay') || e.target.closest('.bb-popup-overlay'));
    }
});

// Close popup on ESC key
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
        closeProductPopup();
    }
});

// Handle accordion functionality (popupEl optional; uses pc25 or bb classes based on overlay)
function initAccordion(popupEl) {
    const popup = popupEl || document.querySelector('.pc25-popup-overlay');
    if (!popup) return;

    const isBb = popup.classList.contains('bb-popup-overlay');
    const accClass = isBb ? 'bb-popup-acc' : 'pc25-acc';
    const h3Class = isBb ? 'bb-popup-acc-h3' : 'pc25-acc-h3';
    const decClass = isBb ? 'bb-popup-acc-dec' : 'pc25-acc-dec';

    const accContainer = popup.querySelector('.' + accClass);
    if (!accContainer) return;

    const h3Tags = accContainer.querySelectorAll('h3');
    h3Tags.forEach(function(h3) {
        if (!h3.classList.contains(h3Class)) {
            h3.classList.add(h3Class);
        }
    });

    accContainer.addEventListener('click', function(e) {
        const h3 = e.target.closest('h3.' + h3Class);
        if (!h3) return;

        e.preventDefault();

        let nextElement = h3.nextElementSibling;
        while (nextElement && !nextElement.classList.contains(decClass)) {
            nextElement = nextElement.nextElementSibling;
        }

        if (nextElement) {
            const isActive = nextElement.classList.contains('active');

            const allDecs = accContainer.querySelectorAll('.' + decClass);
            const allH3s = accContainer.querySelectorAll('.' + h3Class);
            allDecs.forEach(function(dec) { dec.classList.remove('active'); });
            allH3s.forEach(function(h) { h.classList.remove('active'); });

            if (!isActive) {
                nextElement.classList.add('active');
                h3.classList.add('active');
            }
        }
    });
}

// Initialize accordion on DOM ready (collection-landing popup)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAccordion(); });
} else {
    initAccordion();
}

// Re-initialize accordion when popup content is loaded (called from loadProductPopup with overlay el)
const originalLoadProductPopup = window.loadProductPopup;
if (originalLoadProductPopup) {
    window.loadProductPopup = function(handle, isBundle) {
        originalLoadProductPopup(handle, isBundle);
    };
}
